(function(angular, wijmo) {
    'use strict';

    angular.module('onvio.reports')
        .controller('onvio.reports.employeePortalDocumentsCtrl', employeePortalDocumentsCtrl);

    employeePortalDocumentsCtrl.$inject = [
        '$scope',
        '$translate',
        '$window',
        '$uibModal',
        'onvio.reports.employeePortalDocumentsService',
        'onvio.reports.setupFlexgridService',
        'DocumentType',
        'FlexgridConstants'
    ];

    function employeePortalDocumentsCtrl(
        $scope,
        $translate,
        $window,
        $uibModal,
        employeePortalDocumentsService,
        setupFlexgridService,
        DocumentType,
        FlexgridConstants
    ) {
        /*jshint validthis:true */
        var vm = this;
        $scope.alerts = [];
        vm.init = init;
        vm.getClients = getClients;
        vm.onComboboxClientsChange = onComboboxClientsChange;
        vm.fetchTypes = fetchTypes;
        vm.search = search;
        vm.onClickSearch = onClickSearch;
        vm.getDocuments = getDocuments;
        vm.getListComboBoxDocumentsType = getListComboBoxDocumentsType;
        vm.onComboboxDocumentsChange = onComboboxDocumentsChange;
        vm.createFilter = createFilter;
        vm.onChangeInitialBasisDate = onChangeInitialBasisDate;
        vm.onChangeFinalBasisDate = onChangeFinalBasisDate;
        vm.getListSelected = getListSelected;
        vm.addIdsSelectedToList = addIdsSelectedToList;
        vm.localize = localize;
        vm.toggleFilter = toggleFilter;
        vm.changeComboTypeFilter = changeComboTypeFilter;
        vm.setup = setup;
        vm.hideShowColumnsFilter = hideShowColumnsFilter;
        vm.changeFilter = changeFilter;
        vm.manageFilterFocus = manageFilterFocus;
        vm.checkIfHasItemSelected = checkIfHasItemSelected;
        vm.toggleDeleteButton = toggleDeleteButton;
        vm.actions = {
            changeAllSelected: changeAllSelected,
            changeSelected: changeSelected,
            setHasAllSelected: setHasAllSelected,
            setHasAnySelected: setHasAnySelected,
            deleteSelected: deleteSelected,
            deleteItem: deleteItem,
            exportData: exportData,
            refreshData: refreshData
        };
        vm.onChangePage = onChangePage;
        vm.onChangePageSize = onChangePageSize;

        vm.pageTitle = '';
        vm.viewedAllConstant = '';
        vm.viewedYesConstant = true;
        vm.viewedNoConstant = false;
        vm.totalClientPages = 1;
        vm.allSelected = false;
        vm.anySelected = false;
        vm.showFiltersTooltip = undefined;
        vm.hideFiltersTooltip = undefined;
        vm.removeTooltipMessage = undefined;
        vm.buttons = undefined;
        vm.loadingData = false;
        vm.emptyMessage = undefined;
        vm.searched = false;
        vm.filter = {
            client: undefined,
            document: undefined,
            initialBasis: undefined,
            finalBasis: undefined,
            viewed: vm.viewedAllConstant
        };
        vm.filterData = {
            client: undefined,
            document: undefined,
            initialBasis: undefined,
            finalBasis: undefined,
            viewed: vm.viewedAllConstant
        };
        vm.documentTypes = [];
        vm.comboboxClients = {
            headers: [
                'ID',
                $translate.instant('Reports.EmployeePortalDocuments.Filters.Name'),
                $translate.instant('Reports.EmployeePortalDocuments.Filters.Nickname')
            ],
            customRowTemplate: '<span class="combobox-grid-column">{{$row.$item.code}}</span><span class="combobox-grid-column">{{$row.$item.name}}</span><span class="combobox-grid-column">{{$row.$item.nickname}}</span>',
            columnsWidth: ['80', 'auto', 'auto']
        };
        vm.validations = {
            required: '{0} ' + $translate.instant('Reports.EmployeePortalDocuments.Filters.IsRequired'),
            basisDateInvalid: '{0} ' + $translate.instant('Reports.EmployeePortalDocuments.Filters.IsInvalid')
        };

        vm.documents = [{
                value: DocumentType.Payslip,
                label: $translate.instant('Reports.EmployeePortalDocuments.Filters.TypeOfDocument.Payslip')
            },
            {
                value: DocumentType.Vacation,
                label: $translate.instant('Reports.EmployeePortalDocuments.Filters.TypeOfDocument.Vacation')
            },
            {
                value: DocumentType.Income,
                label: $translate.instant('Reports.EmployeePortalDocuments.Filters.TypeOfDocument.Income')
            },
            {
                value: DocumentType.Termination,
                label: $translate.instant('Reports.EmployeePortalDocuments.Filters.TypeOfDocument.Termination')
            },
            {
                value: DocumentType.Other,
                label: $translate.instant('Reports.EmployeePortalDocuments.Filters.TypeOfDocument.Other')
            }
        ];

        vm.currentInfo = {
            page: 1,
            totalItems: 1000,
            numItems: 25
        };
        vm.totalPages = 0;
        vm.pageSizeOption = [
            {
                value: 25,
                label: 25
            },
            {
                value: 50,
                label: 50
            },
            {
                value: 100,
                label: 100
            }
        ];

        vm.idsSelected = [];

        vm.datePickerFormat = undefined;
        vm.generalDateOptions = undefined;
        vm.dpOpenPublicationDate = false;
        vm.dpOpenViewDate = false;

        vm.actionsHeader = undefined;
        vm.competencyHeader = undefined;
        vm.typeHeader = undefined;
        vm.publicationDateHeader = undefined;
        vm.publishedToHeader = undefined;
        vm.viewDateHeader = undefined;

        vm.typeFilter = undefined;
        vm.publicationDateFilter = undefined;
        vm.publishedToFilter = undefined;
        vm.viewDateFilter = undefined;

        vm.ctx = {
            flexgrid: null,
            currentInfo: {
                page: 0,
                pageSize: 30
            },
            columns: [],
            columnBindings: ['competency', 'type', 'publishedTo', 'publicationDate', 'viewDate'],
            data: [], //holds the raw array
            source: [], //holds the actual collections view Object
            columnVis: {},
            columnFocus: {
                competency: true,
                type: false,
                publishedTo: false,
                publicationDate: false,
                viewDate: false,
            },
            columnsToToggle: [{
                    binding: 'competency',
                    header: 'competency'
                },
                {
                    binding: 'type',
                    header: 'type'
                },
                {
                    binding: 'publishedTo',
                    header: 'publishedTo'
                },
                {
                    binding: 'publicationDate',
                    header: 'publicationDate'
                },
                {
                    binding: 'viewDate',
                    header: 'viewDate'
                }
            ],
            totalItems: 0,
            halfWayScrollMark: false,
            filtersHidden: true,
            groupPanelHidden: true
        };
        vm.totalClientPages = 1;

        vm.$onInit = vm.init;

        //Filter feature
        $scope.$watch(function() {
            return vm.ctx.flexgrid;
        }, function(grid) {
            if (grid) {
                setupFlexgridService.initData(grid, vm.ctx, $scope);
                setupFlexgridService.changeDefaultGridSize();
                setupFlexgridService.createFilterColumns();
                setupFlexgridService.setUpColumnVisibility();
                setupFlexgridService.hideShowColumnsFilter();
            }
        });

        $scope.addAlert = function(message, type) {
            $scope.alerts.push({
              type: type,
              msg: message,
              closeable: true
            });
        };

        function init() {
            vm.localize();
        }

        function localize() {
            vm.pageTitle = $translate.instant('Reports.EmployeePortalDocuments.Title');
            vm.showFiltersTooltip = $translate.instant('Reports.EmployeePortalDocuments.Grid.Buttons.ShowFilters');
            vm.hideFiltersTooltip = $translate.instant('Reports.EmployeePortalDocuments.Grid.Buttons.HideFilters');
            vm.removeTooltipMessage = $translate.instant('Reports.EmployeePortalDocuments.Grid.Buttons.Remove');
            vm.emptyMessage = $translate.instant('Reports.EmployeePortalDocuments.Info.Message.YourSearchDidNotReturnAnyResults');

            vm.actionsHeader = $translate.instant('Reports.EmployeePortalDocuments.Grid.Column.Actions');
            vm.competencyHeader = $translate.instant('Reports.EmployeePortalDocuments.Grid.Column.Basis');
            vm.typeHeader = $translate.instant('Reports.EmployeePortalDocuments.Grid.Column.FileType');
            vm.publishedToHeader = $translate.instant('Reports.EmployeePortalDocuments.Grid.Column.PublishedFor');
            vm.publicationDateHeader = $translate.instant('Reports.EmployeePortalDocuments.Grid.Column.PublicationDate');
            vm.viewDateHeader = $translate.instant('Reports.EmployeePortalDocuments.Grid.Column.ViewedDate');

            //dateFormat
            var localeData = $window.moment.localeData();
            vm.datePickerFormat = localeData.longDateFormat('L').toLowerCase().replace('mm', 'MM');

            // date options
            vm.generalDateOptions = {
                showWeeks: false
            };

            // Toolbar definition
            vm.buttons = [
                {
                    label: $translate.instant('Reports.EmployeePortalDocuments.Grid.Buttons.Remove'),
                    icon: 'bento-icon-remove',
                    action: function() {
                        vm.actions.deleteSelected();
                    },
                    disabled: true
                },
                {
                    label: $translate.instant('Reports.EmployeePortalDocuments.Grid.Buttons.Export'),
                    icon: 'bento-icon-exit',
                    action: function() {
                        vm.actions.exportData();
                    }
                },
                {
                    label: $translate.instant('Reports.EmployeePortalDocuments.Grid.Buttons.Refresh'),
                    icon: 'bento-icon-refresh',
                    action: function() {
                        vm.actions.refreshData();
                    }
                }
            ];
        }

        function setup(data, mode) {
            if (mode === 'new') {
                vm.ctx.flexgrid.scrollPosition = new wijmo.Point(0, 0);
                vm.ctx.data = data.items;
                vm.ctx.source = new wijmo.collections.CollectionView(vm.ctx.data);
                vm.ctx.source.pageSize = data.itemsPerPage;
                if (vm.ctx.data.length > 0) {
                    vm.ctx.columns = Object.keys(vm.ctx.data[0]);
                } else {
                    vm.ctx.columns = [];
                }
            }
        }

        function getClients(page, search) {
            page++;
            var clients = [];
            var data;

            // For now the option "All" will not be enabled
            // if (page === 1) {
            //     var clients = [{
            //         code: null,
            //         name: $translate.instant('Reports.EmployeePortalDocuments.Filters.All'),
            //         nickname: null
            //     }];
            // }

            if (page <= vm.totalClientPages) {
                data = employeePortalDocumentsService.getClients(page, search)
                    .then(function(data) {
                        vm.totalClientPages = data.totalPages ? data.totalPages : 1;
                        data.items.forEach(function(item) {
                            clients.push({
                                code: item.code,
                                name: item.name,
                                nickname: item.primaryContactExpanded.nickname,
                                id: item.id
                            });
                        });
                        return clients;
                    });
            }
            return data;
        }

        function onComboboxClientsChange(item) {
            if (item) {
                vm.filter.client = item.name;
                vm.filterData.client = item.id;
            }
        }

        function getDocuments() {
            return vm.documents;
        }

        function onComboboxDocumentsChange(item) {
            if (item) {
                vm.filter.document = item.label;
                vm.filterData.document = item.value;

                if (
                    item.value === DocumentType.Payslip ||
                    item.value === DocumentType.Vacation ||
                    item.value === DocumentType.Other
                ) {
                    vm.fetchTypes();
                }
            }
        }

        function fetchTypes() {
            var type;
            var lang = $translate.instant('Reports.EmployeePortalDocuments.Type.Lang');

            type = vm.filterData.document === DocumentType.Other ?
                vm.filterData.document.slice(0, -1) :
                vm.filterData.document;

            employeePortalDocumentsService.fetchTypes(type.toLowerCase(), lang)
                .then(function(res) {
                    vm.documentTypes = res.types;
                });
        }

        function formatDate(date) {
            if (!date) {
                return;
            }
            var arr = date.split('/');
            return arr[1] + '-' + arr[0];
        }

        function onClickSearch() {
            vm.typeFilter = null;
            vm.publicationDateFilter = null;
            vm.publishedToFilter = null;
            vm.viewDateFilter = null;
            vm.currentInfo.page = 1;
            if (!vm.ctx.filtersHidden) {
                vm.toggleFilter();
            }
            vm.search();
        }

        function search() {
            vm.loadingData = true;
            vm.searched = true;
            vm.allSelected = false;

            if (vm.filter.initialBasis) {
                vm.filterData.initialBasis = $window.moment(formatDate(vm.filter.initialBasis)).format('YYYY-MM-DD');
            } else {
                vm.filterData.initialBasis = '';
            }

            if (vm.filter.finalBasis) {
                vm.filterData.finalBasis = formatDate(vm.filter.finalBasis) + '-' +
                $window.moment(formatDate(vm.filter.finalBasis)).daysInMonth();
            } else {
                vm.filterData.finalBasis = '';
            }

            vm.filterData.viewed = vm.filter.viewed;

            if (vm.filterData.finalBasis < vm.filterData.initialBasis && vm.filterData.finalBasis !== '' && vm.filterData.initialBasis !== '') {
                vm.loadingData = false;
                $scope.addAlert($translate.instant('Reports.EmployeePortalDocuments.Filters.AlertMessage'), 'danger');
            } else {
                employeePortalDocumentsService.search(vm.filterData, vm.currentInfo.page, vm.currentInfo.numItems, vm.createFilter())
                    .then(function(res) {
                        vm.currentInfo.page = res.pageIndex;
                        vm.totalPages = res.totalPages - 1;
                        vm.currentInfo.totalItems = res.totalItems;
                        res.items.forEach(function(item) {
                            if (!item.publishedTo || !item.publishedTo.length) {
                                item.publishedTo = $translate.instant('Reports.EmployeePortalDocuments.Grid.Column.PublishedFor.Text.Default');
                            }
                            if (vm.filterData.document === DocumentType.Income) {
                                item.competency = $window.moment(item.competency).format('YYYY');
                            } else if(vm.filterData.document === DocumentType.Termination) {
                                item.competency = $window.moment(item.competency).format('DD/MM/YYYY');
                            } else {
                                item.competency = $window.moment(item.competency).format('MM/YYYY');
                            }
                            item.type = vm.documentTypes.find(function(type) {
                                return type.id === item.type;
                            });
                            item.type = (item.type) ? item.type.description : null;
                            item.publicationDate = item.createDate ?
                                $window.moment(item.createDate).utcOffset(-6).format('DD/MM/YYYY HH:mm') : '';
                            item.viewDate = item.viewDate ?
                                $window.moment(item.viewDate).utcOffset(-6).format('DD/MM/YYYY HH:mm') : '';
                        });
                        vm.setup(res, 'new');
                        vm.loadingData = false;
                    });
            }
        }

        function basisDateFormat(value) {
            var hasInputDefined = value && value.toString();
            if (hasInputDefined) {
                hasInputDefined = hasInputDefined.replace(/\D/g, '');
                hasInputDefined = hasInputDefined.replace(/^(0\d|1[0-1-2])(\d{4})$/, '$1/$2');
                return hasInputDefined;
            }
        }

        function onChangeInitialBasisDate() {
            vm.filter.initialBasis = basisDateFormat(event.target.value);
        }

        function onChangeFinalBasisDate() {
            vm.filter.finalBasis = basisDateFormat(event.target.value);
        }

        function changeAllSelected(value) {
            vm.allSelected = (value !== undefined ? value : !vm.allSelected);
            vm.ctx.data.forEach(function(item) {
                item.selected = vm.allSelected;
            });

            vm.actions.setHasAnySelected(vm.ctx.data);
        }

        function changeSelected(item) {
            item.selected = !item.selected;
            vm.actions.setHasAllSelected(vm.ctx.data);
            vm.actions.setHasAnySelected(vm.ctx.data);
        }

        function setHasAllSelected(data) {
            var totalSelected = vm.getListSelected(data).length;
            var totalItems = data.length;

            vm.allSelected = totalSelected > 0 && totalSelected === totalItems;
        }

        function setHasAnySelected(data) {
            var totalSelected = vm.getListSelected(data).length;
            var totalItems = data.length;

            vm.anySelected = totalSelected > 0 && totalSelected < totalItems;
            vm.toggleDeleteButton();
            vm.addIdsSelectedToList(data);
        }

        function addIdsSelectedToList(data) {
            vm.idsSelected = [];
            vm.getListSelected(data).forEach(function(item) {
                vm.idsSelected.push(item.id);
            });
        }

        function getListSelected(data) {
            var listSelected = [];
            angular.forEach(data, function(item) {
                if (item.selected) {
                    listSelected.push(item);
                }
            });
            return listSelected;
        }

        function checkIfHasItemSelected() {
            if (vm.anySelected || vm.allSelected) {
                return true;
            } else {
                return false;
            }
        }

        function toggleDeleteButton() {
            vm.buttons[0].disabled = !vm.checkIfHasItemSelected();
        }

        function toggleFilter() {
            vm.ctx.filtersHidden = !vm.ctx.filtersHidden;
            vm.hideShowColumnsFilter();
        }

        function hideShowColumnsFilter() {
            if (vm.ctx.filtersHidden) {
                vm.ctx.flexgrid.columnHeaders.rows[1].height = FlexgridConstants.Height.Invisible;
            } else {
                vm.ctx.flexgrid.columnHeaders.rows[1].height = FlexgridConstants.Height.Headers;
            }
        }

        function changeFilter(filterField) {
            if (filterField === 'publicationDate') {
                vm.publicationDateFilter = vm.publicationDate;
            }
            if (filterField === 'viewDate') {
                vm.viewDateFilter = vm.viewDate;
            }
            vm.search();
            vm.manageFilterFocus(filterField);
        }

        function manageFilterFocus(filterField) {
            Object.keys(vm.ctx.columnFocus).forEach(function(key) {
                if (key === filterField) {
                    vm.ctx.columnFocus[key] = true;
                } else {
                    vm.ctx.columnFocus[key] = false;
                }
            });
        }

        function changeComboTypeFilter(item) {
            vm.typeFilter = item;
            vm.search();
        }

        function getListComboBoxDocumentsType() {
            return vm.documentTypes;
        }

        function createFilter() {
            function buildItemsFilter(by, value, op) {
                return {
                    by: by,
                    op: op,
                    value: value
                };
            }

            var itemsFilter = [];

            if (vm.typeFilter) {
                itemsFilter.push(buildItemsFilter('type', vm.typeFilter.id, 'EQ'));
            }
            if (vm.publicationDateFilter) {
                itemsFilter.push(buildItemsFilter('publicationDate', $window.moment(vm.publicationDateFilter).format('YYYY-MM-DD'), 'EQ'));
            }
            if (vm.publishedToFilter) {
                itemsFilter.push(buildItemsFilter('publishedTo', vm.publishedToFilter, 'LIKE'));
            }
            if (vm.viewDateFilter) {
                itemsFilter.push(buildItemsFilter('viewDate', $window.moment(vm.viewDateFilter).format('YYYY-MM-DD'), 'EQ'));
            }

            var filter = {
                groups: [{
                    useOr: false,
                    items: itemsFilter
                }]
            };

            return {
                filter: filter
            };
        }

        $scope.isLoadingDelete = false;
        function deleteSelected() {
            var confirmModal = $uibModal.open({
                templateUrl: 'reports/employee-portal-documents/employee-portal-documents-removal-confirm-modal.html',
                backdrop: 'static',
                size: 'md',
                bindToController: true,
                scope: $scope,
                controller: ['$uibModalInstance', function($uibModalInstance) {
                    $scope.confirmDelete = function() {
                        $scope.isLoadingDelete = true;
                        employeePortalDocumentsService
                            .removeDocuments(vm.filterData.document, vm.idsSelected.join(','))
                            .then(function() {
                                $scope.isLoadingDelete = false;
                                vm.allSelected = false;
                                vm.anySelected = false;
                                vm.toggleDeleteButton();
                                $uibModalInstance.close(true);
                            })
                            .catch(function() {
                                $scope.isLoadingDelete = false;
                            });
                    };

                    $scope.closeConfirmModal = function() {
                        $uibModalInstance.close(false);
                    };
                }]
            });

            confirmModal.result.then(function(data) {
                if (data) {
                    vm.actions.refreshData();
                }
            });
        }

        function deleteItem(item) {
            var confirmModal = $uibModal.open({
                templateUrl: 'reports/employee-portal-documents/employee-portal-documents-removal-confirm-modal.html',
                backdrop: 'static',
                size: 'md',
                bindToController: true,
                scope: $scope,
                controller: ['$uibModalInstance', function($uibModalInstance) {
                    $scope.confirmDelete = function() {
                        $scope.isLoadingDelete = true;
                        employeePortalDocumentsService.removeDocuments(vm.filterData.document, item.id)
                            .then(function() {
                                $scope.isLoadingDelete = false;
                                $uibModalInstance.close(true);
                            })
                            .catch(function() {
                                $scope.isLoadingDelete = false;
                            });
                    };

                    $scope.closeConfirmModal = function() {
                        $uibModalInstance.close(false);
                    };
                }]
            });

            confirmModal.result.then(function(data) {
                if (data) {
                    vm.actions.refreshData();
                }
            });
        }

        function exportData() {
            // Remove action column from the grid to generate the report
            var actionColumn = vm.ctx.flexgrid.columnHeaders.columns[0];
            vm.ctx.flexgrid.columnHeaders.columns.splice(0, 1);
            // Remove headers
            vm.ctx.flexgrid.columnHeaders.rows.pop();
            vm.ctx.flexgrid.columnHeaders.rows.pop();
            // Generate the file and save it
            var title = vm.pageTitle.toLowerCase().replace(/ /g, '_').replace(/[\s]/g, '').concat('.xlsx');
            wijmo.grid.xlsx.FlexGridXlsxConverter.saveAsync(vm.ctx.flexgrid, {
                includeCellStyles: false
            }, title); // jshint ignore:line

            // Restore the previous configuration of the grid
            vm.ctx.flexgrid.rows.defaultSize = FlexgridConstants.Height.Columns;

            var rowA = new wijmo.grid.Row();
            var rowB = new wijmo.grid.Row();
            vm.ctx.flexgrid.columnHeaders.rows.insert(0, rowA);
            vm.ctx.flexgrid.columnHeaders.rows.insert(0, rowB);
            vm.ctx.flexgrid.columnHeaders.columns.insert(0, actionColumn);
            vm.ctx.flexgrid.columnHeaders.rows[0].height = FlexgridConstants.Height.Headers;
            if (vm.ctx.flexgrid.columnHeaders.rows[2]) {
                vm.ctx.flexgrid.columnHeaders.rows[2].height = FlexgridConstants.Height.Invisible;
            }

            if (vm.ctx.filtersHidden) {
                vm.ctx.flexgrid.columnHeaders.rows[1].height = FlexgridConstants.Height.Invisible;
            } else {
                vm.ctx.flexgrid.columnHeaders.rows[1].height = FlexgridConstants.Height.Headers;
            }
        }

        function refreshData() {
            vm.search();
        }

        function onChangePage(page) {
            if (page) {
                vm.currentInfo.page = page;
            }
            if (!vm.loadingData) {
                vm.search();
            }
        }

        function onChangePageSize(size) {
            if (size) {
                vm.currentInfo.page = 1;
                vm.currentInfo.numItems = size;
            }
            if (!vm.loadingData) {
                vm.search();
            }
        }
    }
})(window.angular, window.wijmo);
